module.exports = __webpack_public_path__ + "static/media/Appeal.55081557.png";